import React from 'react';
import { CrmLoadingState } from './CrmFeedbackState';

function PageLoader({ message = 'Loading...', minHeight = 220 }) {
    return <CrmLoadingState message={message} minHeight={minHeight} />;
}

export default PageLoader;
